export const environment = {
  production: true,
  maintenance: false,
  apiURL: "https://attorneys.georgiabar.org/api/",
  atsSsoUrl: 'https://sbga.atsservices.net/efilesso/ssobytoken.aspx',
  clientAppUrl: 'https://attorneys.georgiabar.org',
  legacyCleUrl: 'https://pages.attorneys.georgiabar.org/CheckCLE_PrevYearCourses.ASP',
  ClientAppSettings: {
    gaBarUrl: 'https://www.gabar.org'
  },
  paymentApiURL: "https://portals.georgiabar.org/api",
};

